import { buildTree as _buildTree } from '../utils';
import { warnTransformsDeprecated } from './warnTransformsDeprecated';
/** @deprecated transform 用法已经过时，请使用 pipeline 来对表格进行拓展 */

export function makeBuildTreeTransform(idProp, parentIdProp) {
  warnTransformsDeprecated('makeBuildTreeTransform');
  return function (_ref) {
    var columns = _ref.columns,
        dataSource = _ref.dataSource;
    return {
      columns: columns,
      dataSource: _buildTree(idProp, parentIdProp, dataSource)
    };
  };
}